import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledTableSoftSkills = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 24px;
`;

export const StyledTableTd = styled.td`
  padding: 20px;

  & .levelItem-right {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledTableContainer = styled.div`
  overflow-y: auto;
  height: calc(100dvh - 409px);
`;

export const StyledTitleTd = styled.td`
  padding: 20px;
`;

export const TableHeader = styled.th`
  padding: 0px 20px 20px;
  height: 40px;
  position: sticky;
  top: 0;
  background-color: ${theme.colors.white};
  z-index: 1;

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
`;

export const TableRow = styled.tr`
  & td:first-child {
    border-radius: ${theme.variables.border_radius_2} 0 0
      ${theme.variables.border_radius_2};
  }
  & td:last-child {
    border-radius: 0 ${theme.variables.border_radius_2}
      ${theme.variables.border_radius_2} 0;
    width: auto;
  }
  &:nth-child(odd) td {
    background-color: ${theme.colors.purple_4};
  }
  &:nth-child(even) td {
    background-color: ${theme.colors.white};
  }
`;
